import { Box } from "@chakra-ui/react";

export default function ErrorState(props: { message: string }) {
  return (
    <Box bg="red.50" borderRadius="md" color="red.600" p={3}>
      {props.message}
    </Box>
  );
}
